import React from 'react';
import {FormProps} from 'antd/lib/form/Form';
import {DefaultColumnSize, ProFormContext} from '../../context';
import {useForm} from 'antd/es/form/Form';
import {Form, Row} from 'antd';
import {Gutter} from 'antd/lib/grid/row';

export interface FormInnerProps<T> extends FormProps<T> {
    disabled?: boolean; // 禁用所有表单字段
    columns?: number; // 每行最多几个表单项
    gutter?: Gutter | [Gutter, Gutter];
    children?: React.ReactNode | React.ReactNode[] | null | any[];
}

export function FormInner<T>({
    columns = DefaultColumnSize,
    gutter,
    children,
    disabled,
    ...extraProps
}: FormInnerProps<T>) {
    const [form] = useForm(extraProps.form);

    return (
        <ProFormContext.Provider
            value={{
                columns: columns!,
                form,
                disabled: disabled!,
            }}>
            <Form {...extraProps} form={form}>
                <Row gutter={gutter}>{children}</Row>
            </Form>
        </ProFormContext.Provider>
    );
}

FormInner.defaultProps = {
    preserve: false,
    disabled: false,
    columns: DefaultColumnSize,
    labelCol: {span: 6},
};
